import React, { useEffect, useState } from "react"
import { useUsers } from "../../core/utils/hooks/useUsers"
import { useFormProject } from "../../core/utils/hooks/useFormProject"
import { useScope, useUser } from "../SelectProjectCompanyContainer"
import Send from "../../core/communication"
import { customToast } from "../../components/Toast"
import AssistanceGenerateLinkScreen from "../../screen/AssistanceGenerateLinkScreen"
import { useCopyClipBoard } from "../../core/utils/hooks/copyToClipBoard"

const originalMessage = {
  title: '*Assistência*:',
  message: `*Assistência*:
 
    {{1}}
     
    👩‍🌾`
}

const customMessage = {
  templateId: "HX84ff16014247594cb094202cc54dc45a",
  title: '*Mensagem personalizada*:',
  message: ``
}

export default function AssistanceGenerateLinkContainer() {
  const [selectedProject, setSelectedProject] = useState(null);
  const [projectOptions, setProjectOptions] = useState([]);
  const userCreated = useUser()
  const { scope, projectsByScope } = useScope()
  const copyToClipBoard = useCopyClipBoard()
  const { users, tagsProject } = useUsers(null, null, selectedProject)
  const { 
    forms, 
    steps, 
    groups, 
    groupQuestions, 
    setSelectedFormId, 
    selectedFormId, 
    setSelectedStepId,
    selectedStepId,
    setSelectedGroupId, 
    selectedGroupId
   } = useFormProject(selectedProject);

  const [selectedFarmers, setSelectedFarmers] = useState([])
  const [assistanceCreated, setAssistanceCreated] = useState({})
  const [selectedSteps, setSelectedSteps] = useState([])
  const [selectedGroups, setSelectedGroups] = useState([])
  const [selectedQuestions, setSelectedQuestions] = useState([])
  const [loadingGenerate, setLoadingGenerate] = useState(false)
  const [filterModalIsOpen, setFilterModalIsOpen] = useState(false)
  const [tagsToFilter, setTagsToFilter] = useState(false)
  const [resetFields, setResetFields] = useState(false)
  const [filter, setFilter] = useState({})

  useEffect(() => {
    if(scope && scope?.id) {
      const newOptions = projectsByScope.map(row => ({ value: row.id, label: row.description }));
      setProjectOptions(newOptions);
      setSelectedProject(newOptions[0].value)
    }
  }, [scope]);


  const handleSelectedFarmers = (farmers) => {
    const selectedFarmers = users
      .filter(user => farmers.includes(user.id))
      .map(({ id, projectId, project, name, whatsapp, email }) => ({
        id,
        projectId,
        project,
        name,
        whatsapp,
        email,
      }))
    
    setSelectedFarmers(selectedFarmers);
  }

  const handleSelectedForm = (e) => {
    setSelectedFormId(e?.value)
    setSelectedSteps(null)
  }

  console.log(selectedStepId)

  const handleSelectedProject = (e) => {
    if(e) {
      setSelectedProject(e?.value);
      setSelectedFormId(null)
      setSelectedSteps(null)
    }
  }

  const handleSelectedSteps = (e) => {
    setSelectedSteps(e);
    setSelectedStepId(e);
  }

  const handleSelectedGroups = (e) => {
    setSelectedGroups(e);
    setSelectedGroupId(e);
  }

  const handleSelectedQuestions = (selecteds) => {
    setSelectedQuestions(selecteds);
  }

  const sendDataToGenerateLink = async () => {
    try {
      const result = await swal({
        title: 'Digite qual mensagem deseja enviar',
        content: {
          element: 'textarea',
          attributes: {
            id: 'textarea-input',
            className: 'swal-content__textarea',
            style: 'width: 100%; height: 150px;',
            placeholder: 'Digite a mensagem (ex: Meu link é {{1}}. Deve incluir {{1}})',
          },
        },
        buttons: {
          cancel: 'Ignorar',
          confirm: {
            text: 'Confirmar',
          },
        },
      });
  
      if (result === null) {
        console.log('Operação ignorada pelo usuário.');
        return;
      }
  
      const message = document.getElementById('textarea-input').value.trim();
  
      if (!message || !message.includes("{{1}}")) {
        const proceed = await swal({
          title: 'Você não digitou, ou esqueceu de digitar {{1}} para configurar seu link.',
          text: 'Deseja prosseguir?',
          icon: 'warning',
          buttons: {
            cancel: 'Cancelar',
            confirm: {
              text: 'Sim, desejo',
            },
          },
        });
  
        if (!proceed) {
          console.log('Operação cancelada pelo usuário.');
          return;
        }
  
        await sendData(originalMessage)
      } else {
        const template = {
          ...customMessage,
          message: message
        }
        await sendData(template)
      }
    } catch (e) {
      console.error('Erro inesperado:', e);
    }
  };

  const sendData = async (template) => {
    setLoadingGenerate(true)
    try {
      const response = await Send.post("/assistance-link/send-one-form", {
        formId: selectedFormId,
        steps: selectedGroups?.map((item) => item?.value) || [],
        questions: selectedQuestions?.map((item) => item?.value) || [],
        userCreated,
        template,
        farmers: selectedFarmers
      })

      if (response.status === "Error") throw new Error("Erro ao enviar formulário(s).")

      customToast(`${response?.links?.length || 0} formulário(s) enviado(s)`, "success")
      setSelectedFormId(null)
      setSelectedFarmers([])
    } catch (error) {
      console.log("Erro ao enviar formulário(s)", error)
      customToast("Erro ao enviar formulário(s)", "error")
    } finally {
      setLoadingGenerate(false)
    }
  }

  const handleCopyLink = (e) => {
    setAssistanceCreated([])

    if (assistanceCreated?.link) {
      copyToClipBoard(assistanceCreated?.link, "Link copiado com sucesso")
    } else {
      customToast("Erro ao copiar link", "error")
    }
  }

  const onChangeFilter = (field, value) => {
    return (value) => {
      setFilter((values) => ({ ...values, [field]: value }))
    }
  }

  const handleTagsToFilter = (e) => {
    setTagsToFilter(!tagsToFilter)
  }

  useEffect(() => {
    if (resetFields) {
      setResetFields(false)
    }
  }, [resetFields])

  const clearFields = () => {
    setResetFields(true)
    setTagsToFilter(false)
  }

  return (
    <AssistanceGenerateLinkScreen
      {...{
        data: users,
        forms,
        steps,
        questions: groupQuestions,
        assistanceCreated,
        handleSelectedFarmers,
        handleSelectedForm,
        handleSelectedSteps,
        handleSelectedGroups,
        selectedFarmers,
        selectedSteps,
        selectedGroups,
        selectedFormId,
        sendDataToGenerateLink,
        loadingGenerate,
        handleCopyLink,
        selectedProject,
        projectOptions,
        handleSelectedProject,
        handleSelectedQuestions,
        selectedQuestions,
        filterModalIsOpen, 
        setFilterModalIsOpen,
        tagsProject,
        onChangeFilter,
        filter,
        clearFields,
        resetFields,
        tagsToFilter,
        handleTagsToFilter,
        groups,
        selectedGroups,
        selectedGroupId,
      }}
    />
  )
}
